// Angular
import { Injectable, Injector } from '@angular/core';
import { HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
// RxJS
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthenticationService } from '../../../core/services/auth.service';

/**
 * More information there => https://medium.com/@MetonymyQT/angular-http-interceptors-what-are-they-and-how-to-use-them-52e060321088
 */
const AUTH_RETRY = new HttpContextToken<boolean>(() => false);

@Injectable()
export class InterceptService implements HttpInterceptor {
	constructor(public auth: AuthenticationService, private injector: Injector) {}
	// intercept request and add token
	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		const auth = this.injector.get(AuthenticationService);
		const skipRefresh = /\/auth\/(login|refresh|logout)(\?|$)/.test(request.url);
		const skipBearer = /\/auth\/(login|refresh)(\?|$)/.test(request.url);

		if (!skipBearer) {
			const token = auth.getToken();
			if (token) {
				request = request.clone({
					setHeaders: {
						Authorization: `Bearer ${token}`
					}
				});
			}
		}
		if (request.body instanceof FormData) {
			//console.log('Ignoring FormData to avoid setHeaders');
		} else {
			if (!request.headers.has('Content-Type')) {
				request = request.clone({
					setHeaders: {
						'Content-Type': `application/json`
					}
				});
			}
		}
		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				if (error?.status !== 401 || skipRefresh || request.context.get(AUTH_RETRY)) {
					return throwError(() => error);
				}
				return auth.refreshSession().pipe(
					switchMap((tokens) => {
						const retry = request.clone({
							context: request.context.set(AUTH_RETRY, true),
							setHeaders: {
								Authorization: `Bearer ${tokens.token}`
							}
						});
						return next.handle(retry);
					}),
					catchError((refreshError) => {
						auth.expireSession();
						return throwError(() => refreshError);
					})
				);
			})
		);
	}
}
